import type { SchemaToType } from '@main/schema-utils';
import { mkInput } from '@main/schema-utils';

export const PolicyAgreementResponseInput = mkInput({
  name: 'PolicyAgreementResponseInput',
  comment: 'Input for collecting policy agreement data during account creation',
  fields: {
    actionType: {
      comment: 'Type of action that triggered the agreement',
      type: 'string',
    },
    controlLabel: {
      comment: 'Label of the control that triggered the agreement',
      type: 'string',
    },
    locale: {
      comment: 'Locale of the user when accepting the agreement',
      type: 'string',
    },
    onlineServicesPolicyUrl: {
      comment: 'URL to the Online Services Agreement',
      type: 'string',
    },
    onlineServicesPolicyLabel: {
      comment: 'Label for the Online Services Agreement',
      type: 'string',
    },
    privacyPolicyUrl: {
      comment: 'URL to the Privacy Policy',
      type: 'string',
    },
    privacyPolicyLabel: {
      comment: 'Label for the Privacy Policy',
      type: 'string',
    },
  },
});

/** Override type */
export type PolicyAgreementResponseInput = SchemaToType<
  typeof PolicyAgreementResponseInput
>;
